let history: string[] = [""];
let cursorIndex = 0;

function push(command: string) {
    history.push(command);
    gotoPresent();
}

function getPreviousCommand() {
    goBackInHistory();
    return history[cursorIndex];
}

function getNextCommand() {
    goForwardInHistory();

    if (atPresent()) {
        return "";
    }

    return history[cursorIndex];
}

function goBackInHistory() {
    --cursorIndex;
    cursorIndex = cursorIndex >= 0 ? cursorIndex : 0;
}

function goForwardInHistory() {
    cursorIndex++;
    cursorIndex = atPresent() ? history.length : cursorIndex;
}

function atPresent() {
    return cursorIndex >= history.length;
}

function gotoPresent() {
    cursorIndex = history.length;
}

function clear() {
    history = [""];
    cursorIndex = 0;
}

export default {
    push: push,
    getPreviousCommand: getPreviousCommand,
    getNextCommand: getNextCommand,
    clear: clear
};
